import { onMounted } from 'vue';
import { Capacitor } from '@capacitor/core';
import AdyenPlugin from '@/capacitor-plugins/AdyenPlugin';
import { useI18n } from 'vue-i18n';
import { Alert } from '@/services/alert.service';

export function useTapToPayLinking() {
  const { t } = useI18n();

  onMounted(async () => {
    if (Capacitor.isPluginAvailable('Adyen')) {
      if (
        (await AdyenPlugin.needsTapToPayLinking()).needsTapToPayLinking &&
        !window.sessionStorage.getItem('tapToPayDismissed')
      ) {
        const { isConfirmed: shouldLinkTapToPay } = await Alert.fire({
          titleText: t('tapToPay.tapToPayLinkingRequired'),
          text: t('tapToPay.tapToPayLinkingRequiredText'),
          icon: 'question',
          showDenyButton: true,
          confirmButtonText: t('yes'),
        });
        if (shouldLinkTapToPay) {
          await AdyenPlugin.linkTapToPay();
        } else {
          window.sessionStorage.setItem('tapToPayDismissed', 'true');
        }
      }
    }
  });
}
